import { get } from './requests'

export const getLinks = () => role => get(['role', role], {})
